import { render, staticRenderFns } from "./SizeChartCreateEdit.vue?vue&type=template&id=db982188&"
import script from "./SizeChartCreateEdit.vue?vue&type=script&lang=js&"
export * from "./SizeChartCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports